import { IconTypes } from '@genial/components';
import { IconographyTypes } from '@genial/icons';
import { Service } from '@genial/services';
import { MetaResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';
import { selectorFamily } from 'recoil';

import { blankMetaResponse } from '../../../utils/blankMetaResponse';

import { CustomerWithdrawalBankItemNormalized, CustomerWithdrawalItemNormalized } from './types';

export const customerWithdrawalsQuery = selectorFamily<
  | {
      data: CustomerWithdrawalItemNormalized[];
      meta: MetaResponse;
    }
  | null
  | undefined,
  { accountId: string | number; searchTerm?: string; page: number; limit?: number }
>({
  key: 'customerWithdrawalsQuery',
  get:
    ({ accountId }) =>
    async () => {
      const { data } = await Service.Finance.V1.getCashoutByListAccountId({
        screenName: 'customerDetail',
        accountId: parseInt(accountId.toString(), 10),
      });

      if (!data) {
        return {
          data: [],
          meta: blankMetaResponse(),
        };
      }

      const normalizedData: CustomerWithdrawalItemNormalized[] = data.map((item) => ({
        ...item,
        transactionDateNormalized: item.transactionDate
          ? Utils.Mask.DateFormat(item.transactionDate, 'dd/MM/yyyy')
          : '--',
        scheduledDateNormalized: item.scheduledDate
          ? Utils.Mask.DateFormat(item.scheduledDate, 'dd/MM/yyyy')
          : '--',
        amountNormalized: Utils.Mask.Money(item.amount),
        transactionIdNormalized: item.transactionId ?? '--',
        statusNormalized: item.status ?? '--',
        statusIconColorNormalized: Utils.ColorToken.fromColor(item.statusIcon.iconColor),
        statusIconNormalized: (item.statusIcon.icon ?? 'Info') as IconographyTypes.Option,
        statusIconSizeNormalized: (item.statusIcon.iconSize as IconTypes.Sizes) ?? 'xxxs',
      }));

      return {
        data: normalizedData,
        meta: blankMetaResponse(),
      };
    },
});

export const customerWithdrawalsListBanksQuery = selectorFamily<
  CustomerWithdrawalBankItemNormalized[] | null | undefined,
  { accountId: string | number }
>({
  key: 'customerWithdrawalsListBanksQuery',
  get:
    ({ accountId }) =>
    async () => {
      const { data } = await Service.Finance.V1.getCashoutByRegisteredBanksAccountId({
        accountId: parseInt(accountId.toString(), 10),
        screenName: 'customerDetail',
      });

      if (!data) {
        return [];
      }

      const normalizedData: CustomerWithdrawalBankItemNormalized[] = data.map((item) => ({
        ...item,
        bankCodeNormalized: item.bankCode ?? '--',
        bankNameNormalized: item.bankName ?? '--',
        bankAgencyNumberNormalized: item.bankAgencyNumber ?? '--',
        bankAgencyDigitNormalized: item.bankAgencyDigit ?? '--',
        bankAccountNumberNormalized: item.bankAccountNumber ?? '--',
        bankAccountDigitNormalized: item.bankAccountDigit ?? '--',
        fullBankName: `(${item.bankCode})  - ${item.bankName} | Ag: ${item.bankAgencyNumber}-${item.bankAgencyDigit} | CC: ${item.bankAccountNumber}-${item.bankAccountDigit}`,
      }));

      return normalizedData;
    },
});
